import { Row } from "react-bootstrap";

import { emptyString } from "../../../../../constants";
import { toTestIdSlug } from "../../../../../shared";
import {
  BRAND_REPORT_LABELS,
  BRAND_REPORT_BREAKDOWN_LABELS,
} from "../../../constants/brandReport.constants";
import BreakdownItem from "./breakdownItem";

const BreakdownSection = ({ data, isSingleSection = false, sectionTitle }) => {
  const titleClassName = isSingleSection
    ? "mt-2 fs-6 fw-semibold text-uppercase"
    : "mt-2 pt-4 border-top fs-6 fw-semibold text-uppercase";

  return (
    <div
      className="d-flex flex-column gap-3"
      data-testid={`breakdown-section-${toTestIdSlug(sectionTitle || emptyString)}`}
    >
      <span className={titleClassName}>
        {BRAND_REPORT_LABELS.COMPLETION_TYPE_BREAKDOWN}
      </span>
      <Row className={`${isSingleSection ? "row-gap-5" : "g-3"}`}>
        <BreakdownItem
          label={BRAND_REPORT_BREAKDOWN_LABELS.POSITIVE}
          data={data.totalPositiveSurveyCompleteCount}
          borderClass="border-left-positive"
        />
        <BreakdownItem
          label={BRAND_REPORT_BREAKDOWN_LABELS.PASSIVE}
          data={data.totalPassiveSurveyCompleteCount}
          borderClass="border-left-passive"
        />
        <BreakdownItem
          label={BRAND_REPORT_BREAKDOWN_LABELS.NEGATIVE}
          data={data.totalNegativeSurveyCompleteCount}
          borderClass="border-left-negative"
        />
        <BreakdownItem
          label={BRAND_REPORT_BREAKDOWN_LABELS.REDIRECT_TO_GOOGLE_REVIEW}
          data={data.totalGoogleReviewCount}
          borderClass="border-left-google"
        />
      </Row>
    </div>
  );
};

export default BreakdownSection;
